window.slideTimer = function () {
    $('.nav-arrow-next').click();
};

$(function () {
    var page = getQueryString('page');
    if (page && !isNaN(parseInt(page))) {
        page = parseInt(page);
    } else {
        page = 1;
    }
    var data = getColumnList('Special_column', page, 11);

    if (data && data.data.length > 0) {
        var count = data.data.length > 3 ? 3 : data.data.length;
        var newlist = '';
        for (var i = 0; i < count; i++) {
            var info = data.data[i];
            if (i == 0) newlist += '<div class="slide-item current" data-index="' + i + '">';
            else newlist += '<div class="slide-item" data-index="' + i + '">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            if (info.thumbnail_urls.length > 0) newlist += '<img src="' + info.thumbnail_urls[0] + '?w=725&h=260&s=3" />';
            else newlist += '<img />';
            newlist += '</a>';
            newlist += '<div class="slide-content">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist += '<div class="slide-title">' + info.title + '</div>';
            newlist += '</a>';
            newlist += '<div class="slide-summary">' + info.summary + '</div>';
            newlist += '</div>';
            newlist += '</div>';
        }

        $('.slide .slide-items').append(newlist);

        while (data.data.length < $('#nav-dots span').length) {
            $('#nav-dots span:last').remove();
        }

        var int = setInterval('slideTimer()', 6000);

        $('.slide-list').on('mouseover', function () {
            window.clearInterval(int);
        });

        $('.slide-list').on('mouseout', function () {
            int = setInterval('slideTimer()', 6000);
        });

        var html = '';
        for (var i = 3; i < data.data.length; i++) {
            var info = data.data[i];
            html +=
                '<div class="special-item">\n' +
                '        <a href="' +
                info.url +
                '" target="_blank" class="special-item-img">\n' +
                '            <img src="' +
                info.thumbnail_urls[0] +
                '?w=516&h=185&s=3" />\n' +
                '        </a>\n' +
                '        <a href="' +
                info.url +
                '" target="_blank" class="special-item-title">' +
                info.title +
                '</a>\n' +
                '    </div>';
        }
        $('.special-list').html(html);

        html = '';
        if (Math.ceil(data.total / 11) > 1) {
            html += '<a href="/cms/special" class="special-page">首页</a>\n';
            for (var i = 0; i < Math.ceil(data.total / 11); i++) {
                if (i + 1 == page) {
                    html += '<a class="special-page selected">' + (i + 1) + '</a>\n';
                } else {
                    html += '<a href="/cms/special?page=' + (i + 1) + '" class="special-page">' + (i + 1) + '</a>\n';
                }
            }
            html += '<a href="/cms/special?page=' + Math.ceil(data.total / 11) + '" class="special-page">末页</a>\n';
        }
        $('.special-pages').html(html);
    }
});
